import script from "./ExpiryTableSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpiryTableSection.vue?vue&type=script&setup=true&lang=ts"

import "./ExpiryTableSection.vue?vue&type=style&index=0&id=19bffd86&scoped=true&lang=css"

import exportComponent from "D:\\Github\\SmsAdminOnlineApplication\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19bffd86"]])

export default __exports__